export type Transform<T, R> = (o: T) => R;

export function lowerCase(value: unknown): string | undefined {
  return value ? String(value).toLowerCase() : undefined;
}

export function stringToJSON<T = unknown>(str: string | undefined): T | undefined {
  try {
    return str && str.length > 0 ? (JSON.parse(str) as T) : undefined;
  } catch {
  }
  return undefined;
}

export function jsonToString(json: unknown): string | undefined {
  return json == null ? undefined : JSON.stringify(json);
}

export function array2delimited(delimiter: string): (array: unknown) => string | undefined {
  return array => (array && Array.isArray(array) ? array.join(delimiter) : "");
}

export function delimited2array(delimiter: string) {
  return (str: string | undefined) => {
    if (str == null || str.length === 0) {
      return [];
    }

    return str.split(delimiter);
  };
}

export function bool2string(b: unknown): string {
  return b ? "1" : "0";
}

export function string2bool(s: string | undefined): boolean {
  return s === "1";
}
